import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0639cf6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "open-orders-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Ordens em aberto", -1))
const _hoisted_3 = { class: "open-orders-table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Ordem"),
    /*#__PURE__*/_createElementVNode("td", null, "Data Inicial"),
    /*#__PURE__*/_createElementVNode("td", null, "Dias aberto")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "Nenhum registro encontrado.", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "table-loading"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "Carregando...", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (!_ctx.items.length && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (!_ctx.items.length && _ctx.loading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.ORD_CODIGO
          }, [
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.verifyIndex(index))
            }, _toDisplayString(item.ORD_CODIGO), 3),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.verifyIndex(index))
            }, [
              _createElementVNode("div", null, _toDisplayString(item.DATA_FORMATADA), 1)
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(_ctx.verifyIndex(index))
            }, [
              _createElementVNode("div", null, _toDisplayString(item.NRO_DIAS_ABERTO), 1)
            ], 2)
          ]))
        }), 128))
      ])
    ])
  ]))
}